import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createClaimantCounselAPI,
  updateClaimantCounselAPI,
  deleteClaimantCounselAPI,
  getClaimantCounselByCaseIDAPI,
  deleteClaimantCounselDocumentAPI,
} from "../../../api/claimantCounsel_api";

// ============================================================================
// ASYNC THUNKS
// ============================================================================

export const getClaimantCounselByCaseIDAction = createAsyncThunk(
  "claimantCounsel/getClaimantCounselByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getClaimantCounselByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createClaimantCounselAction = createAsyncThunk(
  "claimantCounsel/createClaimantCounsel",
  async (claimantCounselData, { rejectWithValue }) => {
    const response = await createClaimantCounselAPI(claimantCounselData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateClaimantCounselAction = createAsyncThunk(
  "claimantCounsel/updateClaimantCounsel",
  async ({ claimantCounselID, claimantCounselData }, { rejectWithValue }) => {
    const response = await updateClaimantCounselAPI(
      claimantCounselID,
      claimantCounselData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteClaimantCounselAction = createAsyncThunk(
  "claimantCounsel/deleteClaimantCounsel",
  async (claimantCounselID, { rejectWithValue }) => {
    const response = await deleteClaimantCounselAPI(claimantCounselID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteClaimantCounselDocumentAction = createAsyncThunk(
  "claimantCounsel/deleteClaimantCounselDocument",
  async ({ documentID }, { rejectWithValue }) => {
    const response = await deleteClaimantCounselDocumentAPI(documentID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
